import { cn } from '@/utils';
import React from 'react';
interface DividerProps {
  className?: string;
  dashed?: boolean;
  border?: {
    direction: 'left' | 'right';
    color: string;
  };
  style?: React.CSSProperties;
  height?: string;
}

const Divider: React.FC<DividerProps> = ({ className, dashed = false, border, style, height = '100%' }) => {
  if (dashed) {
    return (
      <div
        style={{
          background: 'repeating-linear-gradient(to right, transparent, transparent 3px, gray 3px, gray 6px)',
          height,
          ...(border && {
            [`border${border.direction.charAt(0).toUpperCase() + border.direction.slice(1)}`]: `1px solid ${border.color}`,
          }),
          ...style,
        }}
      />
    );
  }
  return (
    <div
      className={cn('mx-2 w-0.5 relative flex items-center', className)}
      style={{
        height,
        ...(border && {
          [`border${border.direction.charAt(0).toUpperCase() + border.direction.slice(1)}`]: `1px solid ${border.color}`,
        }),
        ...style,
      }}
    >
      <div className="w-px absolute bg-[#333537]" style={{ height }} />
      <div className="w-px absolute bg-[#161718]" style={{ left: '1px', height }} />
    </div>
  );
};

export default Divider;
